<template>
  <div class="n1 outItem">
    <div class="content unknow">
      <div :class="['item', { low: leftLow }]">
        <img
          v-if="data.tms[0] && data.tms[0].lurl"
          class="hasTms"
          :src="data.tms[0].lurl"
          alt=""
        />

        <img
          v-else
          :src="require('@/assets/imgs/comm/outDefault'+themeHotfix+'.svg')"
          alt=""
        />

        <div class="name">{{ data.tms[0] ? data.tms[0].na : "?" }}</div>
      </div>
      <div class="center">
        <div v-if="data.st != 0 && data.st != 5" class="vs">VS</div>
        <div :class="['scoreRow']" v-html="centerFn"></div>
        <!-- <div class="etRow" v-if="ET && getOvertime.length">
          <span v-for="(item, key) in getOvertime" :key="key">
            {{ sgsPeList[item.pe][getLocal()] + item.sc[0] + "-" + item.sc[1] }}
          </span>
        </div> -->
      </div>
      <div :class="['item', { low: rightLow }]">
        <img
          v-if="data.tms[1] && data.tms[1].lurl"
          class="hasTms"
          :src="data.tms[1].lurl"
          alt=""
        />

        <img
          v-else
          :src="require('@/assets/imgs/comm/outDefault'+themeHotfix+'.svg')"
          alt=""
        />
        <div class="name">{{ data.tms[1] ? data.tms[1].na : "?" }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Format } from "@/utils/fn";
import { sgsPeList } from "@/utils/filedList";
import { mapState } from "vuex";

export default {
  name: "OutLastItem",
  props: ["data", "ET"],
  data() {
    return sgsPeList;
  },
  methods: {
    getTygData(data) {
      return (data.find((item) => item.tyg == 5) || {}).sc || [0, 0];
    },
  },
  computed: {
    themeHotfix() {
      return this.common.theme == 'dark' ? '-dark' : ''
    },
    ...mapState(["common"]),
    getOvertime() {
      if (this.data.sgs) {
        return this.data.sgs.filter((item) => {
          return (
            (item.pe == 1006 && item.tyg == 5) ||
            (item.pe == 1013 && item.tyg == 5)
          );
        });
      }
      return [];
    },
    centerFn() {
      switch (this.data.st) {
        case 0:
          return `<span class="${this.leftLow ? "low" : ""}">${
            this.scoreData[0]
          }</span> - <span class="${this.rightLow ? "low" : ""}">${
            this.scoreData[1]
          }</span>`;
        case 5:
          return `<span class="${this.leftLow ? "low" : ""}">${
            this.scoreData[0]
          }</span> - <span class="${this.rightLow ? "low" : ""}">${
            this.scoreData[1]
          }</span>`;
      }
      return Format(new Date(this.data.btm), "MM/dd");
    },
    leftLow() {
      if (this.data.st == 4 || this.data.st === undefined) {
        return false;
      }
      return this.scoreData[0] < this.scoreData[1];
    },
    rightLow() {
      if (this.data.st == 4 || this.data.st === undefined) {
        return false;
      }
      return this.scoreData[0] > this.scoreData[1];
    },
    scoreData() {
      let scoreData = (
        (this.data.sgs || []).find((item) => item.tyg == 5) || {}
      ).sc || [0, 0];
      return (
        this.data.sgs?.reduce(
          (prev, item) => {
            if ((item.pe == 1006 || item.pe == 1013) && item.tyg == 5) {
              prev = prev.length > 0 ? prev : [0, 0];
              prev[0] = prev[0] + item.sc[0];
              prev[1] = prev[1] + item.sc[1];
            }
            return prev;
          },
          [...scoreData]
        ) || scoreData
      );
    },
  },
};
</script>
<style lang="scss">
.outItem {
  .low {
    opacity: 0.5;
  }
}
</style>
<style lang="scss" scoped>
.outItem {
  .content {
    display: flex;
    width: 100%;
    justify-content: space-between;
    img {
      vertical-align: top;
    }
    .name {
      margin: 4px 0;
      text-align: center;
    }
    .center {
      //   display: flex;
      //   align-items: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .vs {
        font-family: "DIN";

        color: #5A6375;
        font-size: 18px;
        text-align: center;
      }

      .scoreRow {
        font-family: "DIN";
        color: #5A6375;
        font-size: 14px;
      }
      .etRow {
        color: #5a6375;
      }
    }
    .item {
      flex: 1;
      text-align: center;
    }
  }
  .unknow {
    img {
      width: 34px;
      height: 34px;
    }
  }
  .line {
    display: flex;
    flex-wrap: wrap;
    div {
      width: 50%;
      height: 6px;
      &:nth-child(1) {
        border-left: 2px solid #aeb4bd;
        border-bottom: 2px solid #aeb4bd;
      }
      &:nth-child(2) {
        border-right: 2px solid #aeb4bd;
        border-bottom: 2px solid #aeb4bd;
      }
      &:nth-child(3) {
        border-right: 2px solid #aeb4bd;
      }
    }
  }
  .bottomLine {
    display: flex;
    flex-wrap: wrap;
    div {
      width: 50%;
      height: 6px;
      &:nth-child(3) {
        border-left: 2px solid #aeb4bd;
        border-top: 2px solid #aeb4bd;
      }
      &:nth-child(4) {
        border-right: 2px solid #aeb4bd;
        border-top: 2px solid #aeb4bd;
      }
      &:nth-child(1) {
        border-right: 2px solid #aeb4bd;
      }
    }
  }
}

.n1 {
  width: 200px;
}
</style>

<style lang="scss">
.dark {
  .outItem .content .center .scoreRow {
    color: #fff;
  }
}
</style>